import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-3.5 max-w-271 text-black lg:mt-6 lg:px-7.5',
    content:
      'text-base leading-[1.7] font-light lg:text-lg [&_a]:underline [&_a]:underline-offset-2'
  }
});
